angular.module('cian.serp.item')
.controller('StatusesCtrl', ["$scope", "close", function ($scope, close) {
  var contentForTypes = {
      'top3' : {
        title: 'Топ',
        subtitle: 'В 5 раз больше звонков!',
        text: 'Объявления занимают первые три позиции в&nbsp;поиске и&nbsp;привлекают максимальное внимание потенциальных клиентов',
        url: '/promo/adv#top3',
        icon: '#top3_promo',
        label: 'top3'
      },
      'premium' : {
        title: 'Премиум',
        subtitle: 'В 3 раза больше звонков!',
        text: 'Эффективнее обычных за&nbsp;счёт расположения на&nbsp;верхних позициях поиска',
        url: '/promo/adv#premium',
        icon: '#premium_promo',
        label: 'premium'
      },
      'colorized' : {
        title: 'Выделение цветом',
        subtitle: 'В 1,5 раза больше звонков!',
        text: 'Жёлтый фон делает объявление заметней среди других предложений',
        url: '/promo/adv#color',
        icon: '#brush_promo',
        label: 'color'
      },
      'paid' : {
        title: 'Платное',
        subtitle: false,
        text: 'По&nbsp;статистике, более достоверны и&nbsp;вызывают больше доверия пользователей, чем бесплатные',
        url: '/promo/adv#paid',
        icon: '#paid_promo',
        label: 'paid'
      }
    };

  $scope.statusDataPopup = contentForTypes[$scope.statusInfoType];
  $scope.sendGAStatusEvent = function(label) {
    window.ca && ca('event', {
      name: 'oldevent',
      category: 'PromoVAS',
      action: label,
      label: 'from_card_popup'
    });
  }
}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.statuses.js
// module id = 499
// module chunks = 0